package org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager

enum class ObjectKindTypes {
   TABLE,
   STRUCTURE,
   FURNITURE,
   INTERIOR_DECORATION,
   INDICATOR,
}